export default __webpack_public_path__ + "static/media/gemibasi.07bf95ca.jpg";